import { render } from "./PembayaranQRISModal_c.vue?vue&type=template&id=f49b27e6&scoped=true"
import script from "./PembayaranQRISModal_c.vue?vue&type=script&lang=js"
export * from "./PembayaranQRISModal_c.vue?vue&type=script&lang=js"

import "./PembayaranQRISModal_c.vue?vue&type=style&index=0&id=f49b27e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f49b27e6"

export default script